<template>
  <div class="relative">
    <img
      :src="uri"
      :alt="getAlternative"
      :class="[imgClass, { 'opacity-0': isLoader || isError }]"
      v-show="!isLoader && !isError"
    />

    <div
      v-if="isLoader"
      :class="loaderClass || imgClass"
      class="flex items-center justify-center bg-gray-100"
    >
      <Loader :size="iconClass" />
    </div>

    <div
      v-if="isError"
      :class="loaderClass || imgClass"
      class="flex items-center justify-center bg-gray-50 border border-gray-200"
    >
      <img
        :class="iconClass"
        src="@/assets/images/404/image_not_found.webp"
        alt="Image not found"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useImage } from "@vueuse/core";
import Loader from "./loader.vue";

interface Props {
  uri: string;
  imgClass?: string | string[];
  iconClass?: string;
  loaderClass?: string;
  alt?: string;
}

const props = withDefaults(defineProps<Props>(), {
  imgClass: "h-36 min-w-24",
  iconClass: "h-8",
});

const { isLoading, isReady, error } = useImage(() => ({
  src: props.uri,
}));

const isLoader = computed(() => isLoading.value);
const isError = computed(() => !!error.value);

const getAlternative = computed<string>(
  () =>
    props.alt ||
    `Medium.am artwork-${Math.random().toString(36).substring(2, 8)}`,
);
</script>
